export default __webpack_public_path__ + "static/media/0010.9c670815.jpg";